import { useEffect, useRef } from 'react';

/**
 * useUnsavedGuard
 * Warns the user before leaving the page (browser close/reload) when there are
 * unsaved changes. SPA navigation is not intercepted here to keep compatibility
 * with the BrowserRouter (non-data) setup — the visible "Unsaved changes"
 * badge in the editor communicates state clearly.
 */
export function useUnsavedGuard(dirty) {
  const dirtyRef = useRef(dirty);
  dirtyRef.current = dirty;

  useEffect(() => {
    const onBeforeUnload = (e) => {
      if (dirtyRef.current) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, []);
}
